import { EmptyArray } from "../domain/empty/model";
import { UserRepositoryImplementation } from "../infrastructure/user-repository-implementation";
import { UserFactory } from "../domain/user/model";

import { setCookie, getCookie } from '../utils/http-client'

import { cacheManager } from '../infrastructure/cache-manager';

const repository = new UserRepositoryImplementation();
const CACHE_PREFIX = 'user_profile';

async function createUser(payload: any) {
    const response = await repository.create(payload).toPromise();
    const newUser = UserFactory.create(
        response.data.id,
        response.data.uid,
        response.data.name,
        response.data.phone,
        response.data.document,
        response.data.document_type,
        response.data.address,
        response.data.companyName,
        response.data.email,
        response.data.terms,
        response.data.role_id,
        response.data.url_avatar,
        response.data.created_at,
        response.data.updated_at,
    );
    return newUser;
}

async function updateUser(uid: string, cid: string | null, payload: any) {
    try {
        const response = await repository.update(uid, cid, payload).toPromise();
        cacheManager.invalidate(CACHE_PREFIX); // Invalidate cache after updating
        const newUser = UserFactory.create(
            response.data.id,
            response.data.uid,
            response.data.name,
            response.data.phone,
            response.data.document,
            response.data.document_type,
            response.data.address,
            response.data.companyName,
            response.data.email,
            response.data.terms,
            response.data.role_id,
            response.data.url_avatar,
            response.data.created_at,
            response.data.updated_at,
        );
        return newUser;
    } catch (error) {
        console.error(error);
        return null;
    }
}

async function getProfile(uid: string, cid: string | null) {
    try {
        const cacheKey = `${CACHE_PREFIX}-${uid}-${cid}`;
        const cached = cacheManager.getItem(cacheKey);

        if (cached) {
            return cached;
        }

        const response = await repository.get(uid, cid).toPromise();
        const data = response.data;
        if (data.length === 0) return EmptyArray;

        if (response.data['subscription']) {
            cacheManager.setItem(cacheKey, data);
        }
        return data;
    } catch (error) {
        console.error("Error fetching user profile:", error);
        cacheManager.invalidate(CACHE_PREFIX);
        return null;
    }
}

async function uploadAvatar(uid: string, cid: string | null, file: File) {
    const response = await repository.uploadAvatar(uid, cid, file).toPromise();
    const newUrl = response.url;

    // Actualizar cache (localStorage) via CacheManager
    const cacheKey = `${CACHE_PREFIX}-${uid}-${cid}`;
    const cachedProfile = cacheManager.getItem<any>(cacheKey);

    if (cachedProfile) {
        cachedProfile.url_avatar = newUrl;
        cacheManager.setItem(cacheKey, cachedProfile);
    }

    // Actualizar cookie 'data'
    const cookieData = getCookie('data');
    if (cookieData) {
        try {
            const profile = JSON.parse(cookieData);
            profile.url_avatar = newUrl;
            setCookie('data', JSON.stringify(profile), 30);
        } catch (e) {
            console.error("Error updating cookie data", e);
        }
    }

    return newUrl;
}

async function recoveryPassword(data: any) {
    return repository.passwordRecovery(data).toPromise()
}

const clearAllCachedProfiles = () => {
    cacheManager.invalidate(CACHE_PREFIX);
};


async function updatePassword(uid: string, cid: string | null, password: string) {
    return repository.updatePassword(uid, cid, password).toPromise();
}

export { getProfile, createUser, updateUser, uploadAvatar, clearAllCachedProfiles, recoveryPassword, updatePassword };
